import Pagination from '../../../components/layout/Pagination'
import Photo from '../../../components/Photo'
import firstPhoto from '../../../assets/video/uniqlo/uniqlo_1.png'
import secondPhoto from '../../../assets/video/uniqlo/uniqlo_2.png'
import thirdPhoto from '../../../assets/video/uniqlo/uniqlo_3.png'
import fourthPhoto from '../../../assets/video/uniqlo/uniqlo_4.png'
import fifthPhoto from '../../../assets/video/uniqlo/uniqlo_5.png'

function Uniqlo() {
    return (
        <>
            <div className="contents-wrapper">
                <h2 className='font-sawarabiMincho'>◼︎ ユニクロ - 22FW HEATTECH × 細田守監督</h2>
                <div className='photo-wrapper'>
                    <div className='col left-col'>
                        <Photo src={firstPhoto} />
                        <Photo src={thirdPhoto} />
                        <Photo src={fifthPhoto} />
                    </div>
                    <div className='col right-col'>
                        <Photo src={secondPhoto} />
                        <Photo src={fourthPhoto} />
                    </div>
                </div>
                <div className='credit-wrapper'>
                    <p>
                        ユニクロ - 22FW HEATTECH × 細田守監督<br />
                        <br />
                        DIRCTOR : Yuka Yamaguchi<br />
                        <br />
                    </p>
                </div>
            </div>
            <Pagination nextLink='/video/commercial/gtune-detonation-gaming' />
        </>
    )
}

export default Uniqlo